import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Header from '@/components/site/Header';
import Footer from '@/components/site/Footer';
import { Container } from '@/components/site/Primitives';
import { useLanguage } from '@/context/LanguageContext';
import { SITE } from '@/constants/testIds';

const LAST_UPDATED = '2026-06-12';

const PrivacyPage = () => {
  const { t } = useLanguage();
  return (
    <>
      <Header />
      <main
        data-testid={SITE.privacyPage}
        className="bg-[#F7F8F5] pt-32 lg:pt-40 pb-24 min-h-screen"
      >
        <Container>
          <Link
            to="/"
            data-testid={SITE.privacyBackHome}
            className="inline-flex items-center gap-2 text-sm font-medium text-[#5C5C5C] hover:text-[#00A651] transition-colors mb-8"
          >
            <ArrowLeft size={16} /> {t.privacy.backHome}
          </Link>

          <header className="max-w-3xl">
            <div className="text-xs font-bold tracking-[0.22em] uppercase text-[#00A651]">
              {t.common.brand}
            </div>
            <h1 className="mt-4 font-['Outfit'] text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-[#0B0F0C]">
              {t.privacy.title}
            </h1>
            <p className="mt-4 text-sm text-[#5C5C5C]">
              {t.privacy.lastUpdated}: {LAST_UPDATED}
            </p>
          </header>

          <article className="mt-12 max-w-3xl space-y-10">
            {t.privacy.sections.map((s) => (
              <section key={s.h}>
                <h2 className="font-['Outfit'] text-xl sm:text-2xl font-semibold text-[#0B0F0C]">
                  {s.h}
                </h2>
                <p className="mt-3 text-base text-[#5C5C5C] leading-relaxed">{s.p}</p>
              </section>
            ))}
          </article>
        </Container>
      </main>
      <Footer />
    </>
  );
};

export default PrivacyPage;
